module.exports = __webpack_public_path__ + "static/notice-shadow.69995c27.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/notice-shadow.png
// module id = 1031
// module chunks = 2